import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

interface PaywallRouterContext {
  paywallId: number;
}

export const rootRoute = createRootRouteWithContext<PaywallRouterContext>()({
  component: Outlet,
});
